// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"378":"d3edabe6","533":"d3edabe6","937":"d3edabe6"}[chunkId] + ".chunk.css";
};